// Stable color per fleet, shared by every view that shows fleet badges
// (Fleet Vehicles list, Vehicle Management table, map legends...).
// Color is derived from the fleet id so it never changes between renders,
// sessions or components.

export interface FleetColor {
  /** Chip background */
  bg: string
  /** Chip text */
  text: string
  /** Saturated accent (card border, dots) */
  solid: string
}

export const FLEET_COLORS: FleetColor[] = [
  { bg: '#DBEAFE', text: '#1D4ED8', solid: '#3B82F6' }, // blue
  { bg: '#DCFCE7', text: '#15803D', solid: '#22C55E' }, // green
  { bg: '#FEF3C7', text: '#B45309', solid: '#F59E0B' }, // amber
  { bg: '#F3E8FF', text: '#7E22CE', solid: '#A855F7' }, // purple
  { bg: '#FCE7F3', text: '#BE185D', solid: '#EC4899' }, // pink
  { bg: '#CFFAFE', text: '#0E7490', solid: '#06B6D4' }, // cyan
  { bg: '#FFEDD5', text: '#C2410C', solid: '#F97316' }, // orange
  { bg: '#E0E7FF', text: '#4338CA', solid: '#6366F1' }, // indigo
  { bg: '#D1FAE5', text: '#047857', solid: '#10B981' }, // emerald
  { bg: '#FEE2E2', text: '#B91C1C', solid: '#EF4444' }, // red
]

export function fleetColor(fleetId: number): FleetColor {
  return FLEET_COLORS[Math.abs(fleetId) % FLEET_COLORS.length]
}
